<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{
        type: 'SITE.UPDATE_SUPPLIERS',
        suppliers: $ctrl.suppliers,
        siteId: $ctrl.siteId
      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-dialog wc-dialog-alert="true" wc-dialog-labels="{
            title: 'There was an error adding the suppliers',
            body: 'Please try again later.'
          }" then="$ctrl.catch()"></wc-dialog></catch></fd-dispatcher></then></fd-user>